import type { ReactNode } from 'react';
import React, { useState, Fragment } from 'react';
import { UnmountClosed } from 'react-collapse';
import { ICONS } from 'Components/utils/icon/icons';
import { DropZone } from 'Components/frameworks/drop-zone/DropZone';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ProductCondensed } from 'Components/widgets/product-condensed/ProductCondensed';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { StripButton } from 'Components/frameworks/strip-button/StripButton';
type Props = {
  buttonLabel: string;
  cancelLabel: string;
  children?: ReactNode;
  className?: string;
  collapseLabel?: string;
  expandLabel?: string;
  comparisonClick: () => void;
  comparisonToggle: () => void;
  comparisonUrl: string;
  dropzoneLabel?: string;
  isComparisonActive?: boolean;
  isComparisonSubmitable?: boolean;
  isProductsTopInViewport?: boolean;
  isProductsBottomInViewport?: boolean;
  mandatoryMessage?: string;
  resultsCount?: number;
  selectedItems?: Array<any>;
  selectedItemsMax: number;
  toggleProductSelectedForComparison: ((arg0: string) => any) | null | undefined;
};
export const SearchCompareNarrow = ({
  collapseLabel,
  expandLabel,
  children,
  className,
  dropzoneLabel,
  resultsCount,
  selectedItems = [],
  selectedItemsMax = 3,
  toggleProductSelectedForComparison,
}: Props) => {
  const [isExpanded, setExpanded] = useState(false);
  const selectedItemsCount = selectedItems.length;
  return (
    <Fragment>
      <SiteContainer className={className}>{children}</SiteContainer>
      {!!resultsCount && resultsCount > 0 && (
        <section>
          {!!selectedItemsCount && (
            <div className="absolute bottom-full flex w-full justify-center">
              <StripButton
                className="text-center text-12 font-bold text-black underline"
                height={30}
                onClick={() => setExpanded(!isExpanded)}
              >
                {isExpanded ? collapseLabel : expandLabel}
                <Icon
                  className="transition-transform ms-10 shrink-0"
                  rotation={isExpanded ? 180 : 0}
                  name={ICONS.ARROW_TOP}
                  width="0.625rem"
                />
              </StripButton>
            </div>
          )}
          <UnmountClosed isOpened={isExpanded}>
            {Array(selectedItemsMax)
              .fill(undefined)
              .map((_, idx) => {
                const product = selectedItems[idx];
                const productId = product && product.id;
                return (
                  <div className="mb-20" key={productId || idx}>
                    <DropZone
                      label={dropzoneLabel}
                      number={idx + 1}
                      onClear={
                        productId && toggleProductSelectedForComparison
                          ? () => {
                              toggleProductSelectedForComparison(productId);

                              if (selectedItemsCount - 1 === 0) {
                                setExpanded(!isExpanded);
                              }
                            }
                          : undefined
                      }
                    >
                      {product && <ProductCondensed {...product} />}
                    </DropZone>
                  </div>
                );
              })}
          </UnmountClosed>
        </section>
      )}
    </Fragment>
  );
};
